$square-dimension: 25px;

.chevron {
    max-width: $square-dimension;
    min-width: $square-dimension;
    max-height: $square-dimension;
    min-height: $square-dimension;
}